const defaultState: any = {}

export const translation = (state = defaultState) => {
  return state
}
